export default [
    {
        path: "/purchase/receipt",
        name: "PurchaseReceiptPage",
        component: require("@/components/Purchase/PurchaseReceiptPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Purchase",
                },
                {
                    name : "Receipt"
                }
            ]
        }
    },
    {
        path: "/purchase/receipt/create",
        name: "ReceiptCreationPage",
        component: require("@/components/Purchase/PurchaseReceiptCreationPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Purchase",
                },
                {
                    name : "Receipt",
                    path: '/purchase/receipt',
                    query: {
                        poId : '',
                        supplierName : '',
                        createdDate : '',
                        status : 0,
                        page : 1,
                        itemPerPage : 10,
                    }
                },
                {
                    name : "Buat Receipt"
                }
            ]
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/purchase/index.js